<div class="modal-header">
  <h5 class="modal-title">Attention! Des erreurs sont présentes dans votre questionnaire.</h5>
</div>
<div class="modal-body">
  <p>Certaines erreurs sont présentes dans votre questionnaire. Vous pouvez retourner modifier vos réponses. </p>
  <p> Si vous ne connaissez pas la réponse à une question ou ne savez pas comment corriger l'erreur, vous pouvez tout de
    même soumettre
    le questionnaire et votre comptable communiquera avec vous.</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-light" data-bs-dismiss="modal" type="button">Soumettre
    malgré les erreurs
  </button>
  <button (click)="activeModal.close(true)" class="btn btn-primary" type="button">Retour au formulaire</button>
</div>
